"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var usageStats = [];
exports.recordModeChange = function (mode) {
    usageStats.splice(0, 0, { started: Date.now(), mode: mode });
};
exports.getUsageStats = function () {
    var _a;
    if (!((_a = window.zlbolt) === null || _a === void 0 ? void 0 : _a.options)) {
        return undefined;
    }
    var totalModeUsageMS = {};
    var ended = Date.now();
    for (var _i = 0, usageStats_1 = usageStats; _i < usageStats_1.length; _i++) {
        var period = usageStats_1[_i];
        totalModeUsageMS[period.mode] = (totalModeUsageMS[period.mode] || 0) + (ended - period.started);
        ended = period.started;
    }
    return { totalModeUsageMS: totalModeUsageMS, upgradeAllowed: window.zlbolt.options.allow3DUpgrade };
};
//# sourceMappingURL=usageTracker.js.map